module.exports = __webpack_public_path__ + "img/logo-1.f0d90a83.jpg";